export default {
  SET_TELEPHONES (state, telephones) {
    state.telephones = telephones
  },
  SET_TELEPHONE_FOLDER (state, telephoneFolders) {
    state.telephoneFolders = telephoneFolders
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
}